import React from 'react'
import { Col, Row } from 'react-bootstrap'
import Card from '../../../../../UI/Card/Card'
import { isEmpty } from '../../../../../utils/custom_funtions'
import styles from './RenderText.module.css';


const RenderText = (props) => {
  console.log(props.engOption, props.hindiOption)
  return (
    <Row className="my-2">
      <Col lg={6} md={12}>
        <Card className="h-100">
          {props.parentid &&
            <p>
            <b>Parent QID:</b>{props.parentid}
          </p>
          }
          <p>
            <b>{props.engTitle}:</b>
          </p>
          <div
            dangerouslySetInnerHTML={{
              __html: props.engText,
            }}
          ></div>
          {!isEmpty(props.engOption) && (
            <>
              <p>
                <b>Options:</b>
              </p>
              <ol
                className="row justify-content-between"
                style={{
                  listStyleType: "upper-alpha",
                  marginLeft: "10px",
                }}
              >
                {props.engOption.map(data => {
                  return (
                    <li
                      key={data.option_id}
                      className={`col-5 ${styles.option} ${data.is_correct == 1 && styles.correct}`}
                      dangerouslySetInnerHTML={{ __html: data.option }}
                    />
                  );
                })}
              </ol>
            </>
          )}
        </Card>
      </Col>
      <Col lg={6} md={12}>
        <Card className="h-100">
          <p>
            <b>{props.hindiTitle}:</b>
          </p>
          <div
            dangerouslySetInnerHTML={{
              __html: props.hindiText,
            }}
          ></div>
          {!isEmpty(props.hindiOption) && (
            <>
              <p>
                <b>Options:</b>
              </p>
              <ol
                className="row justify-content-between"
                style={{
                  listStyleType: "upper-alpha",
                  marginLeft: "10px",
                }}
              >
                {props.hindiOption.map(data => {
                  return (
                    <li
                      key={data.option_id}
                      className={`col-5 ${styles.option} ${data.is_correct == 1 && styles.correct}`}
                      dangerouslySetInnerHTML={{ __html: data.option }}
                    />
                  );
                })}
              </ol>
            </>
          )}
        </Card>
      </Col>
    </Row>
  );
}

export default RenderText